
import HttpService from "./htttp.service";

class ReportGenService {
  // 🎯 UPDATED: Added branding_pack_id and target_client
  async generateReport(profileData, isPredictionEnabled, outputType = "pdf", chartIds, chartConfigs = {}, branding_pack_id = null, target_client = null) {
    try {
      if (!Array.isArray(profileData) || profileData.length === 0) {
        throw new Error("No profile data provided for report generation.");
      }

      const payload = {
        data: {
          type: "report-generation",
          attributes: {
            profileData,
            isPredictionEnabled,
            outputType,
            chartIds,
            chartConfigs,
            branding_pack_id, // [NEW]
            target_client // [NEW]
          },
        },
      };

      console.log("ReportGenService Payload:", payload);

      // ✅ Use the new download method
      const response = await HttpService.download(`/reportgen`, payload);

      const fileUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = fileUrl;

      const extension = outputType === "excel" ? "xlsx" : "pdf";
      const filename = `Comparedly-Analysis-${new Date().toISOString().slice(0, 10)}.${extension}`;

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error("Error generating report from backend:", error);
      throw error;
    }
  }

  // 🎯 NEW: Preview Report Method (Returns Blob URL)
  async previewReport(profileData, isPredictionEnabled, outputType = "pdf", chartIds, chartConfigs = {}, branding_pack_id = null, target_client = null) {
    try {
      if (!Array.isArray(profileData) || profileData.length === 0) {
        throw new Error("No profile data provided for report preview.");
      }

      const payload = {
        data: {
          type: "report-generation",
          attributes: {
            profileData,
            isPredictionEnabled,
            outputType,
            chartIds,
            chartConfigs,
            branding_pack_id,
            target_client
          },
        },
      };

      console.log("ReportGenService Preview Payload:", payload);

      // Fetch blob without auto-download
      const response = await HttpService.download(`/reportgen`, payload);
      const fileBlob = new Blob([response], { type: outputType === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "application/pdf" });
      const fileUrl = window.URL.createObjectURL(fileBlob);

      return fileUrl;

    } catch (error) {
      console.error("Error generating report preview:", error);
      throw error;
    }
  }

  // 🎯 NEW: Email Report Method
  async emailReport(profileData, isPredictionEnabled, chartIds, chartConfigs = {}, recipients = [], branding_pack_id = null, target_client = null) {
    try {
      if (!Array.isArray(profileData) || profileData.length === 0) {
        throw new Error("No profile data provided for share.");
      }
      if (!recipients || recipients.length === 0) {
        throw new Error("No recipients provided.");
      }

      const payload = {
        data: {
          type: "report-email",
          attributes: {
            profileData,
            isPredictionEnabled,
            chartIds,
            chartConfigs,
            recipients, // ✅ Pass recipients
            branding_pack_id, // [NEW]
            target_client // [NEW]
          },
        },
      };

      console.log("ReportGenService Email Payload:", payload);

      // Call standard POST for email (expecting 200 OK)
      const response = await HttpService.post(`/reportgen/email`, payload);
      return response;

    } catch (error) {
      console.error("Error sending report email:", error);
      throw error;
    }
  }
}

export default new ReportGenService();
